import {defaultImage} from './defaultImg';

export const detail={
        id:Date.now().toString(),
        pic:[],
        rent:"",
        for:"",
        type:"",
        review:5,
        area:"",
        district:"",
        state:"",
        pin:"",
        information:""
}

export const store = {
        user:{
                id:"",
                email:"",
                name:"User",
                gender:"",
                phone:"",
                pic:defaultImage,
                profile:[],
                request:[]
        },
        teacher:{
                id:"",
                name:"",
                pic:"",
                gender:"",
                fees:"",
                experience:"",
                degree:"",
                language:"",
                courses:"",
                subject:"",
                area:"",
                district:"",
                state:"",
                pin:"",
                review:5,
                info:""
        },
        mess:{
                id:"",
                details:[detail]
        }

}